import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClearanceItemService } from '../clearance-item.service';
import { NotificationsService, Notification } from '../../shared/helper-components/index'
import { ClearanceItem, MassUpdateData } from '../clearance-item.model';
import { ILookup } from '../../shared/lookup';

@Component({
    selector: 'group-name',
    standalone: false,
    templateUrl: './clearance-item-groupname.component.html',
    styleUrls: ['./clearance-item-groupname.component.css']
})
export class ClearanceItemGroupNameComponent implements OnInit {

    @Input()
    itemList: ClearanceItem[] = [];
    @Input()
    projectId: string;
    @Output()
    groupNameUpdated: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
    @Output()
    cancelled: EventEmitter<void> = new EventEmitter<void>();

    @ViewChild('groupNameInput', { static: false }) groupNameInput: ElementRef;

    searchResults: ILookup[];
    filteredGroupNames: string[] = [];
    groupNameForm: FormGroup;
    massUpdateData: MassUpdateData;

    constructor(
        private _fb: FormBuilder,
        private _clearanceItemService: ClearanceItemService,
        private _notificationsService: NotificationsService
    ) {
    }

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.groupNameForm = this._fb.group(
            {
                reportGroupName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(255)]]
            });

        this.ProcessGroupNameSearch();
    }

    ProcessGroupNameSearch(): void {
        this._clearanceItemService.searchTerm(this.groupNameForm.controls['reportGroupName'].valueChanges, this.projectId, 100, 'reportGroups')
            .subscribe(searchResults => {
                this.searchResults = searchResults.find(r => r.lookupType == 'reportGroups').lookupData;
                if (searchResults != null && searchResults.length > 0) {
                    this.filteredGroupNames = this.searchResults.map(r => r.name);
                }
            });
    }

    setFocus() {
        if (this.groupNameInput) {
            this.groupNameInput.nativeElement.focus();
            this.groupNameInput.nativeElement.select();
        }
    }

    updateGroupName() {
        if (!this.groupNameForm.valid) {
            this._notificationsService.add(new Notification('warn', 'Please enter a Group Name.', 'Required Field'));
            return;
        }
        this.groupNameUpdated.next(this.groupNameForm);
    }

    cancelGroupName() {
        this.cancelled.emit();
    }
}
